import m from "../../geodata/es2015/polandLow";
window.am4geodata_polandLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/polandLow.js
// module id = null
// module chunks = 